import { render, staticRenderFns } from "./ffoverdot.vue?vue&type=template&id=4510873e&"
import script from "./ffoverdot.vue?vue&type=script&lang=js&"
export * from "./ffoverdot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports